import { useEffect, useState } from 'react';
import './App.css';
import abi from './contracts/Gotchi.json';
import { ethers, BigNumber } from 'ethers';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import twitter from './img/twitter-logo.png';
import opensea from './img/OpenSea-icon.png';
import logo from './img/logo.gif';

const contractAddress = "0x693653592a4405738A926BDfA74e422fdF5E77e9";

function App() {

  const [currentAccount, setCurrentAccount] = useState(null);
  const [minted, setMinted] = useState(false);
  const [mintOpen, setMintOpen] = useState(false);
  const [totalSupply, setTotalSupply] = useState("");
  const [supply, setSupply] = useState("");
  //const [paused, setPaused] = useState(false);
  const [mintNb, setMintNb] = useState('');
  const [Price, setPrice] = useState(null);

  const checkNetwork = async () => {
    const { ethereum } = window;
    const provider = new ethers.providers.Web3Provider(ethereum);
    var chain = await provider.getNetwork();

    if (chain.chainId !== 1) {
      alert("Wrong network");
      setCurrentAccount(null);
      return false;
    }
    return true;
  }

  const connectWalletHandler = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      alert("Please install Metamask!");
    }
    if (!checkNetwork())
      return;

    try {
      const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
      console.log("Found an account! Address: ", accounts[0]);
      setCurrentAccount(accounts[0]);
    } catch (err) {
      alert(err);
    }
  }

  const freeMintNftHandler = async () => {
    try {
      const { ethereum } = window;

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const nftContract = new ethers.Contract(contractAddress, abi, signer);

        console.log("Initialize payment");
        let nftTxn = await nftContract.freeMint();

        console.log("Minting... please wait");
        await nftTxn.wait();

        console.log(`Minted, see transaction: https://etherscan.io/tx/${nftTxn.hash}`);
        setMinted(true);

      } else {
        console.log("Ethereum object does not exist");
        alert("Ethereum object does not exist");
      }

    } catch (err) {
      console.log(err);
      alert("Error");
    }
  }

  const mintNftHandler = async () => {
    try {
      const { ethereum } = window;

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const nftContract = new ethers.Contract(contractAddress, abi, signer);

        var values = BigNumber.from((mintNb * Price).toString());

        console.log("Initialize payment");
        let nftTxn = await nftContract.Mint(mintNb, { value: values });

        console.log("Minting... please wait");
        await nftTxn.wait();

        console.log(`Minted, see transaction: https://etherscan.io/tx/${nftTxn.hash}`);
        setMinted(true);

      } else {
        console.log("Ethereum object does not exist");
        alert("Ethereum object does not exist");
      }

    } catch (err) {
      console.log(err);
      alert("Error");
    }
  }

  const connectWalletButton = () => {
    return (
      <button onClick={connectWalletHandler} className='cta-button connect-wallet-button'>
        Connect Wallet
      </button>
    )
  }

  const handleChange = (event) => {
    setMintNb(event.target.value);
  };

  const play_game = () => {
    var level = 160; // Game level, by decreasing will speed up
    var rect_w = 46; // Width
    var rect_h = 44; // Height
    var snake_color = "white"; // Snake Color
    var ctx; // Canvas attributes
    var tn = []; // temp directions storage
    var x_dir = [-1, 0, 1, 0]; // position adjusments
    var y_dir = [0, -1, 0, 1]; // position adjusments
    var queue = [];
    var frog = 1; // defalut food
    var map = [];
    var MR = Math.random;
    var X = 5 + (MR() * (rect_w - 10)) | 0; // Calculate positions
    var Y = 5 + (MR() * (rect_h - 10)) | 0; // Calculate positions
    var direction = MR() * 3 | 0;
    var interval = 0;
    var score = 0;
    var sum = 0, easy = 0;
    var i, dir;
    var show_current_score = document.getElementById("score");
    // getting play area 
    var c = document.getElementById('playArea');
    ctx = c.getContext('2d');
    // Map positions
    for (i = 0; i < rect_w; i++) {
      map[i] = [];
    }
    // random placement of snake food
    function random_snake() {
      var x, y;
      do {
        x = MR() * rect_w | 0;
        y = MR() * rect_h | 0;
      }
      while (map[x][y]);
      map[x][y] = 1;
      ctx.fillStyle = snake_color;
      ctx.strokeStyle = "white";
      ctx.lineWidth = 2;
      ctx.strokeRect(x * 10 + 1, y * 10 + 1, 7, 7);
      ctx.shadowColor = 'yellow'; ctx.shadowBlur = 15;
    }
    // Default somewhere placement
    random_snake();
    function set_game_speed() {
      if (easy) {
        X = (X + rect_w) % rect_w;
        Y = (Y + rect_h) % rect_h;
      }
      if (tn.length) {
        dir = tn.pop();
        if ((dir % 2) !== (direction % 2)) {
          direction = dir;
        }
      }
      if ((easy || (0 <= X && 0 <= Y && X < rect_w && Y < rect_h)) && 2 !== map[X][Y]) {
        if (1 === map[X][Y]) {
          score += 1;
          random_snake();
          frog++;
          show_current_score.innerHTML = "Score : " + score;
        }
        //ctx.fillStyle("white");
        ctx.fillRect(X * 10, Y * 10, 9, 9);
        console.log("Hello");

        map[X][Y] = 2;
        queue.unshift([X, Y]);
        X += x_dir[direction];
        Y += y_dir[direction];
        if (frog < queue.length) {
          dir = queue.pop()
          map[dir[0]][dir[1]] = 0;
          ctx.clearRect(dir[0] * 10, dir[1] * 10, 10, 10);
        }
      }
      else if (!tn.length) {
        var show_score = document.getElementById("show");
        var f = "button";
        var g = "Play Again";
        var h = "window.location.reload();";
        var pg = "playButton";
        show_score.innerHTML = "<h1>GAME OVER!</h1><br><br> <u>Your Score:</u> <b>" + score + "</b><br><br> Want to try again?<br><br><br><br><input id=" + pg + " type=" + f + " value=" + g + " onclick=" + h + ">";
        document.getElementById("playArea").style.display = 'none';
        document.getElementById("score").style.display = 'none';
        window.clearInterval(interval);
      }
    }
    interval = window.setInterval(set_game_speed, level);
    show_current_score.innerHTML = "Score : " + score;
    document.onkeydown = function (e) {
      var code = e.keyCode - 37;
      if (0 <= code && code < 4 && code !== tn[0]) {
        tn.unshift(code);
      }
      else if (-5 == code) {
        if (interval) {
          window.clearInterval(interval);
          interval = 0;
        }
        else {
          interval = window.setInterval(set_game_speed, 60);
        }
      }
      else {
        dir = sum + code;
        if (dir == 44 || dir == 94 || dir == 126 || dir == 171) {
          sum += code
        } else if (dir === 218) easy = 1;
      }
    }
    document.addEventListener("keydown", (e) => {
      switch (e.key) {
        case "ArrowLeft":
        case "ArrowRight":
        case "ArrowUp":
        case "ArrowDown":
          e.preventDefault();
          break;
      }
    });
  }

  const mintNbField = () => {
    if (!mintOpen) {
      return (
        <div><FormControl sx={{ m: 1, minWidth: 80 }}>
          <Select
            id="demo-simple-select"
            value={mintNb}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            onChange={handleChange}
          >
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={4}>4</MenuItem>
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={6}>6</MenuItem>
            <MenuItem value={7}>7</MenuItem>
            <MenuItem value={8}>8</MenuItem>
            <MenuItem value={9}>9</MenuItem>
            <MenuItem value={10}>10</MenuItem>
          </Select>
        </FormControl>
          <button onClick={mintNftHandler} className='cta-button mint-nft-button'>
            Mint NFT (0.002) each
          </button>
        </div>

      )
    }
  }

  const mintNftButton = () => {
    if (!minted && !mintOpen) {
      return (
        <button onClick={freeMintNftHandler} className='cta-button mint-nft-button'>
          Get 1 FreeMint
        </button>
      )
    }
    return "";
  }

  useEffect(() => {
    const getVariables = async () => {
      try {
        const { ethereum } = window;
        if (ethereum) {
          const provider = new ethers.providers.Web3Provider(ethereum);
          const signer = provider.getSigner();
          const nftContract = new ethers.Contract(contractAddress, abi, signer);
          setTotalSupply(await nftContract.totalSupply());
          setSupply(await nftContract.MAX_SUPPLY());
          setMintOpen(await nftContract.paused());
          if (currentAccount)
            var nbr = await nftContract._getAux(currentAccount.adress);
          if (nbr)
            setMinted(nbr.toNumber() > 2 ? true : false);
          //setPaused(await nftContract.paused());
          setPrice(await nftContract.price());
        } else {
          console.log("Ethereum object does not exist");
        }

      } catch (err) {
        console.log(err);
      }
    }
    const checkWalletIsConnected = async () => {
      const { ethereum } = window;

      if (!ethereum) {
        console.log("Make sure you have Metamask installed!");
        return;
      } else {
        console.log("Wallet exists! We're ready to go!")
      }
      if (!checkNetwork())
        return;

      const accounts = await ethereum.request({ method: 'eth_accounts' });

      if (accounts.length !== 0) {
        const account = accounts[0];
        console.log("Found an authorized account: ", account);
        setCurrentAccount(account);
      } else {
        console.log("No authorized account found");
      }
    }
    checkWalletIsConnected();
    getVariables();
    play_game();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className='main-app'>
      <h1>OpenSnake Game</h1>
      <p>You can now mint your's and play the game directly on Opensea</p>
      <p>Each mint create a unique Snake Game</p>
      <div id="show"></div>
      <div id="score"></div>
      <canvas id="playArea" width="460" height="440">Sorry your browser does not support HTML5. Try using like Chrome or
        Firefox.</canvas>
      <div>
        Minted out !
      </div>
      {"Minted :" + totalSupply + "/" + supply}

      <p>{!mintOpen ? "" : "Minting Soon"}</p>
      <div className='logoBottom'>
        <img src={twitter} alt='' className="logoTwitter" onClick={() => window.open("https://twitter.com/OpenSnakeGame")}></img>
        <img src={opensea} alt='' className="logoOS" onClick={() => window.open("https://opensea.io/collection/opensnake-game")}></img>
      </div>
    </div>
  )
}

export default App;
